/**
 * The emission shape.
 */
export enum ParticleShapeType {
  /** Emit from the volume of a box. */
  Box = 0,
  /** Emit from a circle. */
  Circle = 1,
  /** Emit from the base of a cone. */
  Cone = 2,
  /** Emit from a half-sphere. */
  Hemisphere = 3,
  /** Emit from a sphere. */
  Sphere = 4,
  /** Emit from a mesh. */
  Mesh = 5
}
